<div class="appContentsContainer">
  <form
    [formGroup]="template"
    (ngSubmit)="onSave()"
    class="formGroup container halfForm"
  >
    <div class="pageTitle" *ngIf="operation === 'creacion'">
      {{ "templates.titleCreate" | translate }}
    </div>
    <div class="pageTitle" *ngIf="operation === 'edicion'">
      {{ "templates.titleEdit" | translate }}
    </div>
    <div class="lineGradient"></div>
    <div class="row shortRow">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="paId" for="paId">Identificador</label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            type="text"
            formControlName="paId"
            [readonly]="operation === 'edicion'"
            maxlength="32"
          />
          <div class="supIndexRequest">*</div>
        </div>
      </div>
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="paDescr" for="paDescr">Descripción</label>
          </div>
        </div>
        <div class="inputContainer">
          <input type="text" formControlName="paDescr" maxlength="64" />
        </div>
      </div>
    </div>
    <div class="pageTitle">Archivo de patrón de impresión</div>
    <div class="lineGradient"></div>
    <div class="row shortRow" *ngIf="operation === 'edicion'">
      <div style="margin-top: 10px; margin-left: 25px">
        <button
          (click)="previewPDF()"
          class="formButtonBack formButton mr-2"
          type="button"
          title="Previsualizar PDF"
        >
          <em class="fas fa-file-pdf far"></em>
        </button>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <app-rich-text-editor
        class="mt-3"
        [value]="templateValue"
      ></app-rich-text-editor>
    </div>
    <div class="buttonsGroup">
      <div class="backButton">
        <button
          class="formButtonBack"
          *ngIf="template.pristine"
          type="button"
          (click)="goList()"
        >
          <em class="fas fa-caret-square-left"></em>
        </button>
        <button
          class="formButtonBack"
          *ngIf="!template.pristine"
          [swal]="confirmSwal"
          type="button"
        >
          <em class="fas fa-caret-square-left"></em>
        </button>
      </div>
      <div class="okButton">
        <div class="centerButton">
          <button class="formButtonOk" type="submit">
            {{ "commons.ok" | translate }}
          </button>
        </div>
      </div>
    </div>
    <swal
      #confirmSwal
      html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
      icon="warning"
      [showCancelButton]="true"
      [swalOptions]="{
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowEscapeKey: false,
        allowOutsideClick: false
      }"
      [focusCancel]="true"
      (confirm)="goList()"
    >
    </swal>
  </form>
</div>
